import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ZEROSIXCREATEORLINKACCOUNTMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  zerosixCreateOrLinkAccountModalDescriptor: _generatedZerosixCreateOrLinkAccountModalDescriptor,
  zerosixCreateOrLinkAccountModalModalDefinition,
  zerosixCreateOrLinkAccountModalDashboardLayout,
  zerosixCreateOrLinkAccountModalConfig,
  zerosixCreateOrLinkAccountModalResolveConfig,
  zerosixCreateOrLinkAccountModalProperties,
} = doodModalConfig(
  {
    name: "Zerosix - Create or link account modal",
    handle: "zerosix-create-or-link-account-modal",
    internal_name: "ZerosixCreateOrLinkAccountModal",
    componentType: 'ZerosixCreateOrLinkAccountModalComponent',
    category: 'modal',
    description: "Zerosix - Create or link account modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "zerosix-create-or-link-account-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function zerosixCreateOrLinkAccountModalDescriptor(): IBlockDescriptor;
export function zerosixCreateOrLinkAccountModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function zerosixCreateOrLinkAccountModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedZerosixCreateOrLinkAccountModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedZerosixCreateOrLinkAccountModalDescriptor, zerosixCreateOrLinkAccountModalProperties, fieldOrder);
}

export {
  zerosixCreateOrLinkAccountModalModalDefinition,
  zerosixCreateOrLinkAccountModalDashboardLayout,
  zerosixCreateOrLinkAccountModalProperties,
  zerosixCreateOrLinkAccountModalConfig,
  zerosixCreateOrLinkAccountModalResolveConfig,
};

export type ZerosixCreateOrLinkAccountModalConfig = typeof zerosixCreateOrLinkAccountModalConfig;
